import $http from '@vue-util/http';

import { errorHandler } from '@/utils/ErrorHandler';
import { SELLER_DETAILS_ENDPOINT } from '#shared/endpoints';
import { ORDER_DETAILS } from 'config';

import { useEnvPropsStore } from '@/stores/useEnvPropsStore';

const { mkpSellerFallbackError } = ORDER_DETAILS;

export const useMkpSellerDetailsStore = defineStore('mkpSellerDetailsStore', {
  state: () => ({
    sellerDetails: [],
    sellerDetailsError: '',
    isLoading: false,
  }),
  actions: {
    SET_SELLER_DETAILS(sellerDetails) {
      this.sellerDetails = sellerDetails;
      this.sellerDetailsError = '';
    },
    SET_SELLER_DETAILS_ERROR(error) {
      if (!error?.keepState) this.sellerDetails = null;
      this.sellerDetailsError = error?.message || error;
    },
    SET_SELLER_DETAILS_LOADER(isLoading) {
      this.isLoading = isLoading;
    },

    async GET_SELLER_DETAILS(reqBody) {
      const envPropsStore = useEnvPropsStore();
      await this.SET_SELLER_DETAILS_ERROR('');
      await this.SET_SELLER_DETAILS_LOADER(true);
      try {
        const response = await $http.post(
          `${SELLER_DETAILS_ENDPOINT}`,
          {
            sellerIds: reqBody,
          },
          {
            headers: {
              'X-Macys-ClientId': 'SITE',
              'X-Macys-DeviceId': envPropsStore.envProps.deviceType,
            },
          },
        );
        await this.SET_SELLER_DETAILS(response.data.sellerDetails);
      } catch (error) {
        await this.SET_SELLER_DETAILS_ERROR(errorHandler(error, mkpSellerFallbackError));
      } finally {
        await this.SET_SELLER_DETAILS_LOADER(false);
      }
    },
  },
});
